import { EthicalBanner } from "../components/EthicalBanner";

import "../assets/scss/pages/_about-us.scss";
import Config from "../Config";

export const AboutUs = () => {
	return (
		<>
			<title>{Config.title("About Us")}</title>
			<EthicalBanner />
		</>
	);
};

export default AboutUs;
